// 通用的设置    我的申请页面 + 待审批 + 已审批
// import newEmployeesAttendance from ""; // 新员工审批异常
// import annualLeaveExtension from "@/backup/ehr/annualLeaveExtension.vue"; // 年假延期申请
// import renewal from "@/backup/ehr/renewal.vue"; // 合同续签
// import card from "@/backup/ehr/card.vue"; // 名片申请
// import personal from "@/backup/ehr/personal.vue"; // 个人申请
// import absence from "@/backup/ehr/absence.vue"; // 休假申请
// import businessTrip from "@/backup/ehr/businessTrip.vue"; // 出差申请
// import cancelBusinessTrip from "@/backup/ehr/cancelBusinessTrip.vue"; // 取消出差申请
// import cancelOutOffice from "@/backup/ehr/cancelOutOffice.vue"; // 取消外出申请
// import outOffice from "@/backup/ehr/outOffice.vue"; // 外出申请
// import overtime from "@/backup/ehr/overtime.vue"; // 加班申请
// import resumption from "@/backup/ehr/resumption.vue"; // 销假申请
export default {
  newEmployeesAttendance: {
    component: () => import('@/backup/ehr/newEmployeesAttendance.vue'),
    serviceUrl: "/treasure/ehr/newEmployeesAttendance/DoProcessInstance",
    recordUrl: "/treasure/ehr/newEmployeesAttendance/DoProcessInstance",
    method: "post",
    recordKey: "qh_abs_004_sta", // 审批记录的字段值
    detailListKey: "qh_abs_004_dtl",
    data: [["instance_id", "instanceId"]],
    title: "异常考勤审批",
    isNotCancel: true //  true 不显示  false 显示 是否不显示撤销按钮 -- 我的申请页面
  },
  annualLeaveExtension: {
    component: () => import('@/backup/ehr/annualLeaveExtension.vue'),
    serviceUrl: "/treasure/ehr/annualLeaveExtension/DoProcessInstance",
    recordUrl: "/treasure/ehr/annualLeaveExtension/DoProcessInstance",
    fileUrl: "/treasure/ehr/annualLeaveExtension/DoGetAttachment",
    fileMethod: "post",
    method: "post",
    recordKey: "qh_abs_011_sta",
    data: [["instance_id", "instanceId"]],
    title: "年假延期",
    isNotCancel: true // 是否不显示撤销按钮 -- 我的申请页面
  },
  renewal: {
    component: () => import('@/backup/ehr/renewal.vue'),
    serviceUrl: "/treasure/ehr/renewal/DoProcessInstance",
    recordUrl: "/treasure/ehr/renewal/DoProcessInstance",
    method: "post",
    data: [["instance_id", "instanceId"]],
    recordKey: "qh_hr_019_sta",
    title: "合同续签",
    isNotCancel: true, // 是否不显示撤销按钮 -- 我的申请页面
    options: {
      isViewPermission: 0, // 不能查看审批记录
      // 特殊的配置
      action: true // 显示  请您审批 单子 的提示语
    }
  },
  card: {
    component: () => import('@/backup/ehr/card.vue'),
    serviceUrl: "/treasure/ehr/card/DoProcessInstance",
    recordUrl: "/treasure/ehr/card/DoProcessInstance",
    method: "post",
    data: [["instance_id", "instanceId"]],
    recordKey: "qh_hr_008_sta",
    title: "名片申请",
    isNotCancel: true, // 是否不显示撤销按钮 -- 我的申请页面
    options: {}
  },
  personal: {
    component: () => import('@/backup/ehr/personal.vue'),
    serviceUrl: "/treasure/ehr/personal/DoProcessInstance",
    recordUrl: "/treasure/ehr/personal/DoProcessInstance",
    method: "post",
    data: [["instance_id", "instanceId"]],
    recordKey: "qh_hr_004_sta",
    title: "员工个人信息修改",
    isNotCancel: true, // 是否不显示撤销按钮 -- 我的申请页面
    options: {}
  },
  absence: {
    component: () => import('@/backup/ehr/absence.vue'),
    serviceUrl: "/treasure/ehr/absence/DoProcessInstance",
    recordUrl: "/treasure/ehr/absence/DoProcessInstance",
    method: "post",
    data: [["instance_id", "instanceId"]],
    recordKey: "qh_abs_002_sta",
    detailListKey: "qh_abs_002_dtl",
    fileKey: "qh_abs_002_atta",
    title: "休假申请",
    detailListTitle: "休假明细",
    options: {}
  },
  businessTrip: {
    component: () => import('@/backup/ehr/businessTrip.vue'),
    serviceUrl: "/treasure/ehr/businessTrip/DoProcessInstance",
    recordUrl: "/treasure/ehr/businessTrip/DoProcessInstance",
    method: "post",
    data: [["instance_id", "instanceId"]],
    recordKey: "qh_abs_005_sta",
    detailListKey: "qh_abs_005_dtl",
    fileKey: "qh_abs_005_atta",
    title: "出差申请",
    detailListTitle: "出差明细",
    options: {}
  },
  cancelBusinessTrip: {
    component: () => import('@/backup/ehr/cancelBusinessTrip.vue'),
    serviceUrl: "/treasure/ehr/cancelBusinessTrip/DoProcessInstance",
    recordUrl: "/treasure/ehr/cancelBusinessTrip/DoProcessInstance",
    method: "post",
    data: [["instance_id", "instanceId"]],
    recordKey: "qh_abs_006_sta",
    detailListKey: "qh_abs_006_dtl",
    fileKey: "qh_abs_006_atta",
    title: "取消出差申请",
    detailListTitle: "取消出差明细",
    options: {}
  },
  cancelOutOffice: {
    component: () => import('@/backup/ehr/cancelOutOffice.vue'),
    serviceUrl: "/treasure/ehr/cancelOutOffice/DoProcessInstance",
    recordUrl: "/treasure/ehr/cancelOutOffice/DoProcessInstance",
    method: "post",
    data: [["instance_id", "instanceId"]],
    recordKey: "qh_abs_010_sta",
    detailListKey: "qh_abs_010_dtl",
    fileKey: "qh_abs_010_atta",
    title: "取消外出申请",
    detailListTitle: "取消外出明细",
    options: {}
  },
  outOffice: {
    component: () => import('@/backup/ehr/outOffice.vue'),
    serviceUrl: "/treasure/ehr/outOffice/DoProcessInstance",
    recordUrl: "/treasure/ehr/outOffice/DoProcessInstance",
    method: "post",
    data: [["instance_id", "instanceId"]],
    recordKey: "qh_abs_009_sta",
    detailListKey: "qh_abs_009_dtl",
    fileKey: "qh_abs_009_atta",
    title: "",
    detailListTitle: "我的明细",
    options: {}
  },
  overtime: {
    component: () => import('@/backup/ehr/overtime.vue'),
    serviceUrl: "/treasure/ehr/overtime/DoProcessInstance",
    recordUrl: "/treasure/ehr/overtime/DoProcessInstance",
    method: "post",
    data: [["instance_id", "instanceId"]],
    recordKey: "qh_abs_008_sta",
    detailListKey: "qh_abs_008_dtl",
    fileKey: "qh_abs_008_atta",
    title: "加班申请",
    detailListTitle: "加班明细",
    options: {}
  },
  resumption: {
    component: () => import('@/backup/ehr/resumption.vue'),
    serviceUrl: "/treasure/ehr/resumption/DoProcessInstance",
    recordUrl: "/treasure/ehr/resumption/DoProcessInstance",
    method: "post",
    data: [["instance_id", "instanceId"]],
    recordKey: "qh_abs_003_sta",
    detailListKey: "qh_abs_003_dtl",
    fileKey: "qh_abs_003_atta",
    title: "销假申请",
    detailListTitle: "销假明细",
    options: {}
  },
  offer: {
    component: () => import('@/backup/ehr/offer.vue'),
    serviceUrl: "/treasure/ehr/offer/DoProcessInstance",
    recordUrl: "/treasure/ehr/offer/DoProcessInstance",
    method: "post",
    recordKey: "qh_hr_001_sta", // 审批记录的字段值
    data: [["instance_id", "instanceId"]],
    title: "offer审批",
    isNotCancel: true //  true 不显示  false 显示 是否不显示撤销按钮 -- 我的申请页面
  },
  leaveOffice: {
    component: () => import('@/backup/ehr/leaveOffice.vue'),
    serviceUrl: "/treasure/ehr/leaveOffice/DoProcessInstance",
    recordUrl: "/treasure/ehr/leaveOffice/DoProcessInstance",
    method: "post",
    recordKey: "qh_hr_011_sta", // 审批记录的字段值
    data: [["instance_id", "instanceId"]],
    title: "离职审批",
    isNotCancel: true //  true 不显示  false 显示 是否不显示撤销按钮 -- 我的申请页面
  },
  backgroundCheck: {
    component: () => import('@/backup/ehr/backgroundCheck.vue'),
    serviceUrl: "/treasure/ehr/backgroundCheck/DoProcessInstance",
    recordUrl: "/treasure/ehr/backgroundCheck/DoProcessInstance",
    method: "post",
    recordKey: "qh_hr_029_sta", // 审批记录的字段值
    data: [["instance_id", "instanceId"]],
    title: "背调异常审批",
    isNotCancel: true //  true 不显示  false 显示 是否不显示撤销按钮 -- 我的申请页面
  },
  passiveResignation: {
    component: () => import('@/backup/ehr/passiveResignation.vue'),
    serviceUrl: "/treasure/ehr/passiveResignation/DoProcessInstance",
    recordUrl: "/treasure/ehr/passiveResignation/DoProcessInstance",
    method: "post",
    recordKey: "qh_hr_012_sta", // 审批记录的字段值
    data: [["instance_id", "instanceId"]],
    title: "被动离职审批",
    isNotCancel: true //  true 不显示  false 显示 是否不显示撤销按钮 -- 我的申请页面
  },
  statutoryOvertime: {
    component: () => import('@/backup/ehr/statutoryOvertime.vue'),
    serviceUrl: "/treasure/ehr/statutoryOvertime/DoProcessInstance",
    recordUrl: "/treasure/ehr/statutoryOvertime/DoProcessInstance",
    method: "post",
    recordKey: "qh_abs_012_sta", // 审批记录的字段值
    data: [["instance_id", "instanceId"]],
    title: "法定加班审批",
    isNotCancel: true //  true 不显示  false 显示 是否不显示撤销按钮 -- 我的申请页面
  },
  specialEntry: {
    component: () => import('@/backup/ehr/special.vue'),
    serviceUrl: "/treasure/ehr/specialEntry/DoProcessInstance",
    recordUrl: "/treasure/ehr/specialEntry/DoProcessInstance",
    method: "post",
    recordKey: "qh_hr_031_sta", // 审批记录的字段值
    data: [["instance_id", "instanceId"]],
    title: "offer前特殊审批",
    isNotCancel: true //  true 不显示  false 显示 是否不显示撤销按钮 -- 我的申请页面
  },
  rehire: {
    component: () => import('@/backup/ehr/rehire.vue'),
    serviceUrl: "/treasure/ehr/rehire/DoRehDetailData",
    recordUrl: "/treasure/ehr/rehire/DoRehDetailData",
    method: "post",
    recordKey: "qh_hr_001_sta", // 审批记录的字段值
    data: [["instance_id", "instanceId"]],
    title: "重新雇佣审批",
    isNotCancel: true //  true 不显示  false 显示 是否不显示撤销按钮 -- 我的申请页面
  },
  outsourcingDimission: {
    component: () => import('@/backup/ehr/outsourcingDimission.vue'),
    serviceUrl: "/treasure/ehr/outsourcingDimission/DoProcessInstance",
    recordUrl: "/treasure/ehr/outsourcingDimission/DoProcessInstance",
    method: "post",
    recordKey: "qh_hr_027_sta", // 审批记录的字段值
    data: [["instance_id", "instanceId"]],
    title: "外包离场审批",
    isNotCancel: true //  true 不显示  false 显示 是否不显示撤销按钮 -- 我的申请页面
  },
  notice: {
    component: () => import('@/backup/ehr/notice.vue'),
    serviceUrl: "/treasure/ehr/notice/DoProcessInstance",
    recordUrl: "/treasure/ehr/notice/DoProcessInstance",
    method: "post",
    recordKey: "qh_hr_026_sta", // 审批记录的字段值
    data: [["instance_id", "instanceId"]],
    title: "公告审批",
    isNotCancel: true //  true 不显示  false 显示 是否不显示撤销按钮 -- 我的申请页面
  },
  transfer: {
    component: () => import('@/backup/ehr/transfer.vue'),
    serviceUrl: "/treasure/ehr/transfer/DoProcessInstance",
    recordUrl: "/treasure/ehr/transfer/DoProcessInstance",
    method: "post",
    recordKey: "qh_hr_013_sta", // 审批记录的字段值
    data: [["instance_id", "instanceId"]],
    title: "转岗审批",
    isNotCancel: true //  true 不显示  false 显示 是否不显示撤销按钮 -- 我的申请页面
  },
  changeType: {
    component: () => import('@/backup/ehr/changeType.vue'),
    serviceUrl: "/treasure/ehr/changeType/DoProcessInstance",
    recordUrl: "/treasure/ehr/changeType/DoProcessInstance",
    method: "post",
    recordKey: "qh_hr_006_sta", // 审批记录的字段值
    data: [["instance_id", "instanceId"]],
    title: "员工类型变更",
    isNotCancel: true //  true 不显示  false 显示 是否不显示撤销按钮 -- 我的申请页面
  },
  becomeRegular: {
    component: () => import('@/backup/ehr/becomeRegular.vue'),
    serviceUrl: "/treasure/ehr/becomeRegular/DoProcessInstance",
    recordUrl: "/treasure/ehr/becomeRegular/DoProcessInstance",
    method: "post",
    recordKey: "qh_hr_002_sta", // 审批记录的字段值
    data: [["instance_id", "instanceId"]],
    title: "转正审批",
    isNotCancel: true //  true 不显示  false 显示 是否不显示撤销按钮 -- 我的申请页面
  },
  changeSign: {
    component: () => import('@/backup/ehr/changeSign.vue'),
    serviceUrl: "/treasure/ehr/changeSign/DoProcessInstance",
    recordUrl: "/treasure/ehr/changeSign/DoProcessInstance",
    method: "post",
    recordKey: "qh_hr_020_sta",
    data: [["instance_id", "instanceId"]],
    title: "转签审批",
    isNotCancel: true //  true 不显示  false 显示 是否不显示撤销按钮 -- 我的申请页面
  },
};
